import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "typeface-roboto";

import { initApi, IS_DEMO, USE_MSW } from "@shape/reef-shared";
import { App } from "./App";
import "./index.css";
import { setupTelemetry } from "@shape/otel";

console.log("app_version: ", __APP_VERSION__);

setupTelemetry("reef.web");

const enableMocking = async () => {
  if (IS_DEMO) {
    if (USE_MSW) {
      console.log("🔧 Iniciando MSW para mocks...");
      const { setupWorker } = await import("msw/browser");
      const { handlers } = await import("./mocks");

      const worker = setupWorker(...handlers);

      return worker.start({
        quiet: true,
      });
    } else {
      console.log("🔧 Iniciando MirageJS para mocks...");
      const { makeServer } = await import("./configServer/server");
      makeServer();
    }
  }
};

(async () => {
  await enableMocking();
  initApi();
  const root = createRoot(document.getElementById("root") as HTMLElement);
  root.render(<App />);
})();
